// SPEC-COLLECTION-HISTORY-FILTER-AND-ROWCAP-FIX-01 (D-395) ITEM_2 — PostgREST の全件ページング取得。
//   Supabase JS は .limit()/.range() 無しだと既定1000行で黙って切り捨てる(D-394 実証)。明細が必要で
//   合計RPCに置換できない経路(月次Excel等)は、本ヘルパで .range() を回して全件を取り切る。
//   「1000行で切れたことに気づけない実装にしない」ため、ページが pageSize 未満になるまで必ず継続し、
//   expectedCount を渡した場合は取得件数と突き合わせ、不一致なら throw する(黙って過小を出さない)。
//
// buildQuery: 呼ぶたびに「新しい」PostgREST クエリ(.range() 適用前)を返すファクトリ。
//   例) () => supabase.from('t').select('...').eq(...).order(...)
export async function fetchAllRange(buildQuery, { pageSize = 1000, expectedCount = null } = {}) {
  if (typeof buildQuery !== 'function') throw new Error('fetchAllRange: buildQuery must be a function factory')
  const all = []
  let from = 0
  for (;;) {
    const { data, error } = await buildQuery().range(from, from + pageSize - 1)
    if (error) throw error
    const batch = data ?? []
    all.push(...batch)
    if (batch.length < pageSize) break // 短いページ=終端(1000ちょうどでも次ページ空で検出)
    from += pageSize
  }
  if (expectedCount != null && all.length !== expectedCount) {
    // 取り切れていない(または多すぎる)=黙って過小/過大な帳票を出さない(ITEM_2/AC3)。
    throw new Error(`fetchAllRange: 取得 ${all.length} 件が期待件数 ${expectedCount} 件と不一致(全件取得に失敗)`)
  }
  return all
}
